// App utils
import { datajs } from '../shared/utils';

export default class SiteHeaderSearchToggle {
	static init() {
		const toggleSiteHeaderSearchBtn = datajs('site-header-search-toggle');
		const siteHeaderSearchInput = datajs('site-header-search-input');

		const showSiteHeaderSearch = () => {
			toggleSiteHeaderSearchBtn.setAttribute('aria-expanded', 'true');
			document.body.classList.add('has-siteHeaderSearch');
			siteHeaderSearchInput.focus();
			return false;
		};

		const hideSiteHeaderSearch = () => {
			toggleSiteHeaderSearchBtn.setAttribute('aria-expanded', 'false');
			document.body.classList.remove('has-siteHeaderSearch');
			return false;
		};

		const handleDocumentKeyUp = (e) => {
			// Close menu using Esc key.
			if (e.keyCode === 27) {
				hideSiteHeaderSearch();
			}
		};

		// Show off canvas menu
		if (toggleSiteHeaderSearchBtn) {
			toggleSiteHeaderSearchBtn.addEventListener('click', function () {
				if (document.body.classList.contains('has-siteHeaderSearch')) {
					hideSiteHeaderSearch();
				} else {
					showSiteHeaderSearch();
				}
			});

			// Handle document keyup event
			document.addEventListener('keyup', handleDocumentKeyUp);
		}
	}
}
